import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const Facility = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-15%", "15%"]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.15, 1.05, 1.15]);

  return (
    <section ref={ref} className="relative w-full h-[70vh] lg:h-[95vh] overflow-hidden bg-black">
      <motion.div
        style={{ y, scale }}
        className="absolute inset-0"
      >
        <img
          src="/products/facility.jpg"
          alt="SconeCORE Enterprises manufacturing facility"
          className="w-full h-full object-cover"
        />
      </motion.div>

      <div className="absolute inset-0 bg-gradient-to-b from-[#0A2A1E]/60 via-transparent to-[#0A2A1E]/95" />

      <div className="relative z-10 h-full flex flex-col justify-between p-5 lg:p-10 text-[#FAF9F6]">
        <div className="flex justify-between overline">
          <span>Unit I · Gudli, Udaipur — Unit II · Chopanki, Bhiwadi</span>
          <span className="hidden md:inline">Rajasthan · India</span>
        </div>

        <div className="max-w-[1400px] mx-auto w-full">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-[-0.02em] max-w-4xl"
          >
            Two units, <br />
            <span className="font-display-italic text-[#C6F035]">one</span>{" "}
            uncompromising standard.
          </motion.h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10">
            <div>
              <div className="overline text-[#C6F035] mb-2">Unit I — Udaipur</div>
              <p className="text-sm md:text-base text-[#FAF9F6]/80 leading-snug">
                F-177, Gudli Industrial Area,<br />
                Udaipur, Rajasthan — 313001
              </p>
            </div>
            <div>
              <div className="overline text-[#C6F035] mb-2">Unit II — Bhiwadi</div>
              <p className="text-sm md:text-base text-[#FAF9F6]/80 leading-snug">
                H1-230, Chopanki Industrial Area,<br />
                Bhiwadi, Alwar (NCR), Rajasthan — 301019
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Facility;
